export const STARTING_PROMPT_GROUPS: string[][] = [
  [
    'Explain the Amount threshold rule',
    'What does the Adverse media rule check?',
    'What happens after a rule triggers?',
    'What is the difference between a ping and a case?',
  ],
  [
    'How has the number of new cases changed over the last 90 days?',
    'Summarise the oldest unassigned open case',
    'Summarise the newest case and what triggered it',
    'What was the largest transaction this week, and how was it handled?',
  ],
  [
    'How do I create a new rule?',
    'How do I add an individual manually?',
    'How do I create a report?',
    'How do I set up a risk class?',
  ],
];

// One prompt per group, in group order, and the group left out when only two fit. Both are
// drawn together and kept for the conversation, so a resize never changes which group goes.
export type StartingPromptDraw = {
  prompts: string[];
  leftOutGroup: number;
};

export const pickStartingPrompts = (random: () => number): StartingPromptDraw => ({
  prompts: STARTING_PROMPT_GROUPS.map(
    (prompts) => prompts[Math.floor(random() * prompts.length)],
  ),
  leftOutGroup: Math.floor(random() * STARTING_PROMPT_GROUPS.length),
});

// Three show when they fit, otherwise the two without the left-out group, otherwise the first
// of those two. They keep their group order whatever the count.
export const startingPromptsToShow = (
  { prompts, leftOutGroup }: StartingPromptDraw,
  count: number,
): string[] => (count >= prompts.length
  ? prompts
  : prompts.filter((_, group) => group !== leftOutGroup).slice(0, Math.max(count, 1)));

// Rounding of the measured heights is absorbed here, so a panel that fits the prompts
// exactly settles on one count rather than flipping between two on every measurement.
const FIT_TOLERANCE_PX = 1;

// The most prompts that fit in `space`, where each prompt takes its own height plus the gap
// above it. Never fewer than one: the smallest panel is sized to hold one.
export const startingPromptCountThatFits = (
  draw: StartingPromptDraw,
  heights: Record<string, number>,
  gap: number,
  space: number,
): number => {
  for (let count = draw.prompts.length; count > 1; count -= 1) {
    const needed = startingPromptsToShow(draw, count)
      .reduce((total, prompt) => total + (heights[prompt] ?? 0) + gap, 0);
    if (needed <= space - FIT_TOLERANCE_PX) return count;
  }
  return 1;
};
